<div class="row" *ngIf="!noCharacteristicsData;else noData">
  <div>
    <table class="width">
      <tr class="fund-header">
        <th class="row-header">Fundamental</th>
        <th>{{fundId}}</th>
        <th>
          <div class="tool-tip-cell" *ngIf ="!(portfolioModel?.profileData?.isBalanced || portfolioModel?.profileData?.isExternalFund)">
            <label>Benchmark<sup *ngIf="benchmarkFootNote?.text">{{benchmarkFootNote?.id}}</sup></label>
            <c11n-tooltip [autoOrientation]="false" colorMode="on-light"  direction="left" labelText="Benchmark">
              <span c11nTooltipContent>{{ fundCharacteristic?.benchmarkShortName || '(Benchmark)' }}</span>
            </c11n-tooltip>
          </div>
          <div class="tool-tip-cell" *ngIf ="(portfolioModel?.profileData?.isBalanced) && !(portfolioModel?.profileData?.isExternalFund)">
            <label>Benchmark<sup *ngIf="benchmarkFootNote?.text">{{benchmarkFootNote?.id}}</sup></label>
            <c11n-tooltip [autoOrientation]="false" colorMode="on-light" direction="left" labelText="Benchmark">
              <span c11nTooltipContent>{{ fundCharacteristic?.benchmarkShortName || '(Benchmark)' }}</span>
            </c11n-tooltip>
          </div>
        </th>
      </tr>
      <tr class="fund" *ngIf ="portfolioModel?.profileData?.isConvertibleFund">
        <td class="row-header">Number of securities</td>
        <td data-rpa-tag-id="symbolNumberOfSecurities">
          {{ fundCharacteristic?.fund?.numberOfSecurities ? fundCharacteristic?.fund?.numberOfSecurities: '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)"  data-rpa-tag-id="benchmarkNumberOfSecurities">
          {{ fundCharacteristic?.benchmark?.numberOfSecurities ? fundCharacteristic?.benchmark?.numberOfSecurities: '&mdash;' }}
        </td>
      </tr>
      <tr class="fund" *ngIf ="portfolioModel?.profileData?.isConvertibleFund">
        <td class="row-header">Conversion premium</td>
        <td data-rpa-tag-id="symbolConvPrem">
          {{ fundCharacteristic?.fund?.conversionPremium ? fundCharacteristic?.fund?.conversionPremium + '%': '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)"  data-rpa-tag-id="benchmarkConvPrem">
          {{ fundCharacteristic?.benchmark?.conversionPremium ? fundCharacteristic?.benchmark?.conversionPremium + '%': '&mdash;' }}
        </td>
      </tr>
      <tr class="fund" *ngIf ="portfolioModel?.profileData?.isConvertibleFund">
        <td class="row-header">Average coupon</td>
        <td data-rpa-tag-id="symbolAvgCoupon">
          {{ fundCharacteristic?.fund?.averageCoupon ? fundCharacteristic?.fund?.averageCoupon + '%': '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkAvgCoupon">
          {{ fundCharacteristic?.benchmark?.averageCoupon ? fundCharacteristic?.benchmark?.averageCoupon + '%': '&mdash;' }}
        </td>
      </tr>
      <tr class="fund" *ngIf ="portfolioModel?.profileData?.isConvertibleFund || portfolioModel?.profileData?.isStableValueFund">
        <td class="row-header">Average duration</td>
        <td data-rpa-tag-id="symbolAvgDuration">
          {{ fundCharacteristic?.fund?.averageDuration ? fundCharacteristic?.fund?.averageDuration: '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkAvgDuration">
          {{ fundCharacteristic?.benchmark?.averageDuration ? fundCharacteristic?.benchmark?.averageDuration: '&mdash;' }}
        </td>
      </tr>
      <tr class="fund" *ngIf ="portfolioModel?.profileData?.isStableValueFund">
        <td class="row-header">Average maturity</td>
        <td data-rpa-tag-id="symbolAverageMaturity">
          {{ fundCharacteristic?.fund?.averageMaturity ? fundCharacteristic?.fund?.averageMaturity: '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkAverageMaturity">
          {{ fundCharacteristic?.benchmark?.averageMaturity ? fundCharacteristic?.benchmark?.averageMaturity: '&mdash;' }}
        </td>
      </tr>
      <tr class="fund" *ngIf ="portfolioModel?.profileData?.isConvertibleFund">
        <td class="row-header">Foreign holdings</td>
        <td data-rpa-tag-id="symbolForeignHoldings">
          {{ fundCharacteristic?.fund?.foreignHolding ? fundCharacteristic?.fund?.foreignHolding + '%': '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkForeignHoldings">
          {{ fundCharacteristic?.benchmark?.foreignHolding ? fundCharacteristic?.benchmark?.foreignHolding + '%': '&mdash;' }}
        </td>
      </tr>
      <tr class="fund" *ngIf ="portfolioModel?.profileData?.isBalanced && ((!portfolioModel?.profileData?.isFundOfFunds && portfolioModel?.profileData?.isInternalFund) ||
      (portfolioModel?.profileData?.isExternalFund && !portfolioModel?.profileData?.isHybridFund ))" >
         <td class="row-header">Turnover rate (Fiscal Year-end {{fundCharacteristic?.fund?.turnoverRateDate | ESTPipe }})</td>
        <td data-rpa-tag-id="symbolTurnoverRate">
          {{ fundCharacteristic?.fund?.turnoverRate ? fundCharacteristic?.fund?.turnoverRate + '%': '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkTurnoverRate">
          {{ fundCharacteristic?.benchmark?.turnoverRate ? fundCharacteristic?.benchmark?.turnoverRate + '%': '&mdash;' }}
        </td>
      </tr>
      <tr class="fund" *ngIf ="(portfolioModel?.profileData?.isBalanced && ((!portfolioModel?.profileData?.isFundOfFunds && portfolioModel?.profileData?.isInternalFund) ||
      (portfolioModel?.profileData?.isExternalFund && !portfolioModel?.profileData?.isHybridFund ))) &&
                                !portfolioModel?.profileData?.isAssetAllocationFund">
        <td class="row-header">Short-term reserves</td>
        <td data-rpa-tag-id="symbolShortTermReserves">
          {{ fundCharacteristic?.fund?.shortTermReserves ? fundCharacteristic?.fund?.shortTermReserves + '%': '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkShortTermReserves">
          {{ fundCharacteristic?.benchmark?.shortTermReserves ? fundCharacteristic?.benchmark?.shortTermReserves: '&mdash;' }}
        </td>
      </tr>
      <tr class="fund">
        <td class="row-header">Fund total net assets as of
          {{  fundCharacteristic?.fund?.totalNetAssetsDate | ESTPipe }}</td>
        <td data-rpa-tag-id="symbolFundNetAssets">
          {{ fundCharacteristic?.fund?.totalNetAssets ? (fundCharacteristic?.fund?.totalNetAssets | amount): '&mdash;'}}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkFundNetAssets">
          {{ fundCharacteristic?.benchmark?.totalNetAssets ? (fundCharacteristic?.benchmark?.totalNetAssets | amount): '&mdash;' }}
        </td>
      </tr>
      <tr class="fund" *ngIf ="(portfolioModel?.profileData?.isBalanced || portfolioModel?.profileData?.isStableValueFund) &&
                           portfolioModel?.profileData?.hasMoreThan1ShareClass">
        <td class="row-header">Share class total net assets</td>
        <td data-rpa-tag-id="symbolShareNetAssets">
          {{ fundCharacteristic?.fund?.shareClassTotalNetAssets ? (fundCharacteristic?.fund?.shareClassTotalNetAssets | amount): '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkShareNetAssets">
          {{ fundCharacteristic?.benchmark?.shareClassTotalNetAssets ? (fundCharacteristic?.benchmark?.shareClassTotalNetAssets | amount): '&mdash;' }}
        </td>
      </tr>
    </table>
  </div>
</div>
  <ng-template #noData>
    <p *ngIf="noCharacteristicsData" class="no-data">This information is temporarily unavailable.</p>
  </ng-template>
